// extracted by mini-css-extract-plugin
module.exports = {"FormBody":"VoteResultsForm_FormBody__pUnb1","PanelBody":"VoteResultsForm_PanelBody__2lPil","Controls":"VoteResultsForm_Controls__2fFmy"};